module.exports = __webpack_public_path__ + "img/logo_sign_in.e78ede78.png";